import { render, staticRenderFns } from "./operatorAllocation.vue?vue&type=template&id=3c1ddfa3&scoped=true&"
import script from "./operatorAllocation.vue?vue&type=script&lang=js&"
export * from "./operatorAllocation.vue?vue&type=script&lang=js&"
import style0 from "./operatorAllocation.vue?vue&type=style&index=0&id=3c1ddfa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ddfa3",
  null
  
)

export default component.exports